module.exports = __webpack_public_path__ + "img/grendmarker.b34e9066.png";